import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://gandaraschool.com";

interface PageMeta {
  title: string;
  description: string;
  canonicalPath?: string;
  noIndex?: boolean;
}

function setMetaTag(attribute: string, key: string, content: string) {
  let el = document.querySelector(`meta[${attribute}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attribute, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href: string) {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = href;
}

function setRobotsMeta(noIndex: boolean) {
  let el = document.querySelector('meta[name="robots"]');
  if (noIndex) {
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow");
  } else if (el) {
    el.remove();
  }
}

export function usePageMeta({ title, description, canonicalPath, noIndex }: PageMeta) {
  const location = useLocation();

  useEffect(() => {
    document.title = title;

    setMetaTag("name", "description", description);
    setMetaTag("property", "og:title", title);
    setMetaTag("property", "og:description", description);

    const url = `${BASE_URL}${canonicalPath || location.pathname}`;
    setMetaTag("property", "og:url", url);
    setCanonical(url);

    setRobotsMeta(!!noIndex);
  }, [title, description, canonicalPath, noIndex, location.pathname]);
}
